import { IContactInfo } from './contact-card.models';
import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'contact-card',
  template: require('./contact-card.component.html'),
  styles: [require('./contact-card.component.scss')],
})
export class ContactCardComponent {
  @Input() contactInfo: IContactInfo | any;
  @Output() contactClickEmitter = new EventEmitter<IContactInfo>();

  public onCardClick(contactInfo: IContactInfo, emitter: EventEmitter<IContactInfo>): void {
    emitter.emit(contactInfo);
  }
}
